import { Container, Graphics } from "@pixi/react";
import React from "react";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { PixiSettings } from "../../../../pixiSettings";
import { usePrimaryUIToolbarDimensionsV2 } from "../../../../Hooks/usePrimaryUIToolbarDimensionsV2";
import ButtonSound from "../Buttons/ButtonSound";
import ButtonMenu from "../Buttons/ButtonMenu";
import { FEATURES_CONFIG } from "../../../../featuresConfig";
import {
  drawToolbarBackground,
  TOOLBAR_BACKGROUND_OPACITY,
} from "./ToolbarBackgrounds";

const bottomIsFront = FEATURES_CONFIG.TOOLBAR.BOTTOM.BACKGROUND_MODE === "front";

const ToolbarBottomSecond = () => {
  const { dimensions, device, orientation } = useDimensions();
  const toolbar = usePrimaryUIToolbarDimensionsV2();

  // Only render on mobile portrait
  if (
    device !== PixiSettings.DEVICE.MOBILE ||
    orientation !== PixiSettings.ORIENTATION.PORTRAIT
  ) {
    return null;
  }

  return (
    <Container
      name="secondary_toolbar_bottom_second"
      x={(dimensions.width - toolbar.width) / 2}
      y={dimensions.height - toolbar.height}
      zIndex={10}
    >
      {/* Background — rendered here when mode is "front" (on top of game) */}
      {bottomIsFront && (
        <Graphics
          name="toolbar_bottom_second_bg_front"
          zIndex={0}
          draw={(g) =>
            drawToolbarBackground(
              g,
              toolbar.width,
              toolbar.height,
              TOOLBAR_BACKGROUND_OPACITY,
              FEATURES_CONFIG.TOOLBAR.BOTTOM.TOOLBAR_COLOR,
            )
          }
        />
      )}

      {/* Sound button — left side */}
      <ButtonSound toolbar={toolbar} />

      {/* Menu button — right side */}
      <ButtonMenu toolbar={toolbar} />
    </Container>
  );
};

export default ToolbarBottomSecond;
